import styled from "@emotion/styled";
var ImageWrapper = /*#__PURE__*/ styled("div", {
    target: "e1n3toov0"
})("position:relative;min-width:", function(param) {
    var _w = param.w, w = _w === void 0 ? "19px" : _w;
    return w;
}, ";height:", function(param) {
    var _h = param.h, h = _h === void 0 ? "19px" : _h;
    return h;
}, ";margin-right:", function(props) {
    return props.hasMarginRight ? "0.3125rem" : 0;
}, ";margin-top:0.25rem;");
export { ImageWrapper };
